module.exports = __webpack_public_path__ + "static/media/vegan.36b588ff.svg";